import { get as getFromStorage, set as setInStorage, STORAGE_DOMAINS } from './storage/GQStorage';

export const documentState = {
    title: "",
    keywords: [],
    seqIds: "",
}

export const ftDocManagerState = {
    open: false,
    documents: {}
}

export const getInitialManagerValue = (managerKey) => {
    return getFromStorage(managerKey, ftDocManagerState, { parse: true });
};

export const getInitialDocValue = (patentId) => {
    return getFromStorage(patentId, documentState, { parse: true });
};

export const getInitialSeqIdValue = () => {
    return getFromStorage('seqIds', [], { parse: true });
};

export const getInitialKeywordValue = () => {
    return getFromStorage('keywords', [], { parse: true });
};



const defaultTextFields = {
    "Title": true,
    "Abstract": true,
    "Claims": true,
    "Description": true,
    "Classifications": true,
    "LegalEvents": true,
    "USPair": true,
    "Citations": true

}
export const getInitialTextFieldsValue = () => {

    let textFields = getFromStorage('TextFields', null, { parse: true });
	
	if(textFields == undefined || textFields == null || textFields ==""){
		textFields = defaultTextFields;
        setInStorage('TextFields', textFields, STORAGE_DOMAINS.CACHE);
	}
		
	return textFields
};